import { ProgressOverviewSkeleton } from "../ProgressOverview/ProgressOverviewSkeleton";
import {
	type SkillProficiencySkeletonVariant,
	SkillSectionSkeleton,
} from "./SkillSectionSkeleton";

export type LanguageLearningProgressSkeletonProps = {
	numSections?: number;
	numStats?: number;
	showTipPlaceholders?: boolean;
	showOverviewSubtitle?: boolean;
	proficiencyVariant?: SkillProficiencySkeletonVariant;
};

export const LanguageLearningProgressSkeleton = ({
	numSections = 2,
	numStats,
	showTipPlaceholders = true,
	showOverviewSubtitle,
	proficiencyVariant,
}: LanguageLearningProgressSkeletonProps) => (
	<>
		<ProgressOverviewSkeleton
			numStats={numStats}
			showTipPlaceholder={showTipPlaceholders}
			showSubtitle={showOverviewSubtitle}
		/>
		{Array.from({ length: numSections }).map((_, sectionIndex) => (
			<SkillSectionSkeleton
				// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton sections
				key={sectionIndex}
				showTipPlaceholder={showTipPlaceholders}
				proficiencyVariant={proficiencyVariant}
			/>
		))}
	</>
);
